import React from 'react'
import { Box, Flex } from '@moonpig/launchpad-components'
import { useLocaleText } from '../locale'
import { useProductStore } from '../../../contexts/product'
import { E_CARD_SIZE_ID } from '../../../constants'
import {
  IconSystemEnvelope,
  IconSystemFastDelivery,
} from '@moonpig/launchpad-assets'
import { theme } from '@moonpig/launchpad-theme'
import { useDispatchCutOffQuery } from '../../../queries/DispatchCutOff'
import { useDispatchCutOffTimer } from '../../Dispatch/useDispatchCutOff'

export const SimplifiedDispatchModule = () => {
  const [{ product, variant }] = useProductStore()
  const dispatchCutOff = useDispatchCutOffQuery(product.category.department)
  const { isVisible, message } = useDispatchCutOffTimer(dispatchCutOff)
  const localiseText = useLocaleText()

  const isPhysicalCard = variant.key !== E_CARD_SIZE_ID

  const physicalCard = isVisible ? (
    <Flex gap={8}>
      <IconSystemFastDelivery
        width={24}
        color={theme.colors.colorInteractionIcon}
      />
      {message}
    </Flex>
  ) : null

  const eCard = (
    <Flex gap={8}>
      <IconSystemEnvelope
        width={24}
        color={theme.colors.colorInteractionIcon}
      />
      {localiseText('simplified_dispatch_ecard')}
    </Flex>
  )
  const moduleToRender = isPhysicalCard ? physicalCard : eCard

  return <Box mb={moduleToRender ? 7 : 0}>{moduleToRender}</Box>
}
